import { EPartsLower } from '../../../types/fio';

export function getQueryIndex(currentPartFIO: EPartsLower) {
  switch (currentPartFIO) {
    case EPartsLower.surname:
      return 0;

    case EPartsLower.name:
      return 1;

    default:
      return 2;
  }
}
